import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { AuthStore } from '../../shared/auth/services';
import {BusinessService} from '../services/business.service';
import {Business} from '../models/business.model';

@Injectable({
  providedIn: 'root'
})
export class BusinessResolver implements Resolve<Business[]> {
  constructor(
    private businessService: BusinessService,
    private authStore: AuthStore
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Business[]> {
    const startTime = performance.now();
    console.log(`[BusinessResolver] resolve START at ${startTime.toFixed(0)}ms`);

    const currentUser = this.authStore.getCurrentUser();

    if (!currentUser || !currentUser._id) {
      console.warn(`[BusinessResolver] No authenticated user found after ${(performance.now() - startTime).toFixed(0)}ms`);
      return of([]);
    }

    console.log(`[BusinessResolver] User found, starting API call after ${(performance.now() - startTime).toFixed(0)}ms`);

    // Check user role and load businesses accordingly
    if (currentUser.role === 'staff' && currentUser.invitedByBusinessId) {
      // For staff users, load the specific business they were invited to
      return this.businessService.getBusinessById(currentUser.invitedByBusinessId).pipe(
        map(business => business ? [business] : []),
        tap(businesses => {
          console.log(`[BusinessResolver] Staff businesses loaded after ${(performance.now() - startTime).toFixed(0)}ms`);
          // Store the businesses in the service
          this.businessService.setMyBusinesses(businesses);

          // If there are businesses, set the first one as current
          if (businesses && businesses.length > 0) {
            this.businessService.setCurrentBusiness(businesses[0]);
          }
        }),
        catchError(error => {
          console.error(`[BusinessResolver] Error loading staff business after ${(performance.now() - startTime).toFixed(0)}ms:`, error);
          return of([]);
        })
      );
    } else {
      // For owner users (default behavior)
      return this.businessService.getBusinessesByOwnerId().pipe(
        tap(businesses => {
          console.log(`[BusinessResolver] Owner businesses loaded after ${(performance.now() - startTime).toFixed(0)}ms, count=${businesses.length}`);
          // Store the businesses in the service
          this.businessService.setMyBusinesses(businesses);

          const currentBusiness = this.businessService.getCurrentBusiness();
          if (!currentBusiness && businesses.length > 0) {
            this.businessService.setCurrentBusiness(businesses[0]);
          }
        }),
        catchError(error => {
          console.error(`[BusinessResolver] Error loading businesses after ${(performance.now() - startTime).toFixed(0)}ms:`, error);
          return of([]);
        })
      );
    }
  }
}
